var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { EngageMessageType } from "engage-common/messages";
import DisplayText, { TextVariant } from "../DisplayText";
import Dropdown, { DropdownOption } from "../Dropdown";
import Button from "../Button";
import { EngageContext } from "../../context";
import { DefaultTeamExplanation } from "./CreateTeams";
var useStyles = createUseStyles(function (theme) {
    var _a, _b;
    var _c, _d;
    return ({
        joinPage: {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        teamSelect: (_a = {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "80%"
            },
            _a[theme.breakpoints.down("md")] = {
                maxWidth: "100%",
                padding: [10, 10]
            },
            _a),
        explanation: {
            textAlign: "center"
        },
        prompt: {
            margin: [80, 0, 20]
        },
        actionButton: {
            display: "block",
            margin: [32, "auto"],
            padding: [16, 16],
            width: (_c = theme.welcome.actionButton.width) !== null && _c !== void 0 ? _c : 250,
            border: theme.welcome.actionButton.border,
            color: theme.welcome.actionButton.color,
            borderRadius: 30,
            fontWeight: (_d = theme.welcome.actionButton.fontWeight) !== null && _d !== void 0 ? _d : 400,
        },
        dropdown: (_b = {},
            _b[theme.breakpoints.up("md")] = {
                width: 400,
            },
            _b.width = 280,
            _b)
    });
});
export default function JoinTeam(_a) {
    var _b, _c;
    var setFormValue = _a.setFormValue, formValues = _a.formValues, lobbyValidation = _a.lobbyValidation;
    var classes = useStyles();
    var theme = useTheme();
    var sendMessage = useContext(EngageContext).sendMessage;
    var teamExplanation = lobbyValidation === null || lobbyValidation === void 0 ? void 0 : lobbyValidation.teamExplanation;
    var teams = lobbyValidation === null || lobbyValidation === void 0 ? void 0 : lobbyValidation.teams;
    var teamChanged = function (value) {
        if (setFormValue) {
            setFormValue("selectedTeam", value);
        }
    };
    var onJoin = function () {
        if (lobbyValidation) {
            sendMessage(__assign({ type: EngageMessageType.JoinLobby, lobbyID: lobbyValidation.lobbyID }, formValues));
        }
    };
    return (React.createElement("div", { className: classes.joinPage },
        React.createElement("div", { className: classes.teamSelect },
            React.createElement(DisplayText, { variant: TextVariant.s28reg, color: "white", className: classes.explanation }, (teamExplanation === null || teamExplanation === void 0 ? void 0 : teamExplanation.length) ? teamExplanation : DefaultTeamExplanation),
            React.createElement(DisplayText, { variant: TextVariant.s28reg, color: "white", className: classes.prompt }, "Select your team below:"),
            React.createElement(Dropdown, { name: "teamName", value: (_b = formValues["selectedTeam"]) !== null && _b !== void 0 ? _b : "default", onChange: teamChanged, className: classes.dropdown },
                React.createElement(DropdownOption, { value: "default", disabled: true }, "Please select"),
                teams.map(function (t) {
                    return React.createElement(DropdownOption, { value: t.key, key: t.key }, t.name);
                })),
            React.createElement(Button, { className: classes.actionButton, backgroundColor: (_c = theme.welcome.actionButton.bgColor) !== null && _c !== void 0 ? _c : "secondary", onClick: onJoin, disabled: !formValues["selectedTeam"], lighten: theme.welcome.actionButton.lighten },
                React.createElement(DisplayText, { variant: TextVariant.smallButton }, "Join")))));
}
;
//# sourceMappingURL=JoinTeam.js.map